import { useState } from 'react';

import { azureAuthentication } from 'utils/functions/authentication';
import authentication from 'configs/authentication';
import LoginComponent from 'modules/accountManagement/components/LoginComponent';

const { loginPopup } = azureAuthentication();
const { redirectUrlCookieName } = authentication;
// ###############################################################
// <------------------------ Constants -------------------------->
// ###############################################################
// ###############################################################
// <---------------------- End Constants ------------------------>
// ###############################################################
const LoginContainer = () => {
  // ###############################################################
  // <------------------------- Globals --------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- End Globals ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useState --------------------------->
  // ###############################################################
  const [isAuthenticating, setIsAuthenticating] = useState(false);
  const [authenticationError, setAuthenticationError] = useState('');
  // ###############################################################
  // <---------------------- End useState ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useEffect -------------------------->
  // ###############################################################
  // ###############################################################
  // <---------------------- End useEffect ------------------------>
  // ###############################################################
  // ###############################################################
  // <--------------------- rest of hooks ------------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------- End rest of hooks ---------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Logic ---------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Logic -------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Actions --------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- End Actions ------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- UI Handlers ------------------------->
  // ###############################################################
  const handleSubmitBtnClick = async () => {
    setIsAuthenticating(true);
    const dateAfterOneWeek = new Date(new Date().setHours(168));
    loginPopup(dateAfterOneWeek)
      .then(() => {
        const returnURL = sessionStorage.getItem(redirectUrlCookieName) || '/';
        document.location.href = returnURL;
      })
      .catch(err => {
        setIsAuthenticating(false);
        setAuthenticationError(err.errorMessage);
      });
  };
  // ###############################################################
  // <--------------------- End UI Handlers ----------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Render --------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Render ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Return UI ------------------------->
  // ###############################################################
  return (
    <LoginComponent
      isAuthenticating={isAuthenticating}
      authenticationError={authenticationError}
      handleSubmitBtnClick={handleSubmitBtnClick}
    />
  );
  // ###############################################################
  // <----------------------- End Return UI ----------------------->
  // ###############################################################
};

LoginContainer.propTypes = {};

LoginContainer.defaultProps = {};

export default LoginContainer;
